import { Logo } from '../MapPanels/Logo';

import { Button } from '@/components/ui/button';
import { useConfigStore } from '@/store/ConfigStore';

interface ServiceOutageProps {
  paragraphs?: string[];
}

export const ServiceOutage = (props: ServiceOutageProps) => {
  const { paragraphs = ['Please try again later.', 'Our team has been notified and are investigating the issue.'] } =
    props;
  const config = useConfigStore((state) => state.config);

  const handleReturnToHomepage = () => {
    window.location.href = config?.homepageUrl || 'https://cleanairroutes.org/';
  };

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-[#F3F6FA] dark:bg-gray-900">
      <div className="w-full bg-white px-6 py-3 dark:bg-gray-800">
        <div className="mx-auto max-w-screen-lg">
          <Logo />
        </div>
      </div>

      <div className="flex flex-1 flex-col items-center justify-center p-8">
        <div className="mx-auto w-full max-w-screen-lg">
          <div className="flex flex-col gap-6">
            <h1 className="text-[36px] leading-[1.1] font-semibold tracking-[-0.5px] text-[#0B2265] dark:text-white">
              Sorry, there is a problem with the service
            </h1>
            <div className="flex flex-col gap-4">
              {paragraphs.map((paragraph, index) => (
                <p key={index} className="text-[19px] leading-[1.5] text-balance text-[#474C5E] dark:text-gray-300">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>

          <div className="mt-8">
            <Button onClick={handleReturnToHomepage}>Return to homepage</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
